import { I18n, Language } from 'paliari-js-utils'
import pt_br from './locales/pt-br'
import Fecha from 'fecha'

const i18n = new I18n({ pt_br }, 'pt_br')
const language = new Language(i18n, Fecha)

export { i18n }
export default {
  install(vue) {
    vue.prototype.$i18n = i18n
    vue.prototype.$language = language
  },
}
